const DATA_TNR_PREFIX = "data-tnr-";

/**
 * Add data attribute(s) to generated HTML
 *
 * @param {Object, Array, String} data
 * @return a string that contains data attribute(s)
 */
const setDataTnr = (data) => {
  if (typeof data === 'string')
    return data.length === 0 ? '' : `${DATA_TNR_PREFIX}${ data }`;
  else if (Array.isArray(data))
    return data.map(name =>  name.length === 0 ? '' : `${DATA_TNR_PREFIX}${ name }`).join(' ');
  else if (typeof data === 'object')
    return Object.keys(data).map(key => `${DATA_TNR_PREFIX}${ key }="${ data[key] }"`).join(' ');

  return '';
};

/**
 * Add data attribute(s) on a node of document
 *
 * @param Node an element on dom
 * @param {Object, Array, String} data
 *
 */
const addDataTnrOnNode = (data, node) => {
  if (typeof data === 'string') {
    if (data.length > 0)
      node.setAttribute(`${DATA_TNR_PREFIX}${ data }`, '');
  } else if (Array.isArray(data)) {
    data.forEach(name => {
      if (name.length > 0)
        node.setAttribute(`${DATA_TNR_PREFIX}${ name }`, '');
    });
  } else if (typeof data === 'object') {
    Object.keys(data).forEach(key => {
      node.setAttribute(`${DATA_TNR_PREFIX}${ key }`, `${data[key]}`);
    });
  }
};

/**
 * Add data attributes on element of a jQuery selection
 *
 * @param jQueryElement a selection by jQuery
 * @param {Object, Array, String} data
 */
const addDataTnrOnJQueryElement = (data, jQueryElement) => {
  jQueryElement.get().forEach(node => {
    addDataTnrOnNode(data, node);
  });
};

/**
 * Remove data attribute(s) on a node of document
 *
 * @param Node an element on dom
 * @param {Object, Array, String} data
 */
const removeDataTnrOnNode = (data, node) => {
  if (typeof data === 'string') {
    const dataTnrAttributeName = `${DATA_TNR_PREFIX}${ data }`;
    if (node.hasAttribute(dataTnrAttributeName))
      node.removeAttribute(dataTnrAttributeName);
  } else if (Array.isArray(data)) {
    data.forEach(name => {
      const dataTnrAttributeName = `${DATA_TNR_PREFIX}${ name }`;
      if (node.hasAttribute(dataTnrAttributeName))
        node.removeAttribute(dataTnrAttributeName);
    });
  } else if (typeof data === 'object') {
    Object.keys(data).forEach(key => {
      node.removeAttribute(`${DATA_TNR_PREFIX}${ key }`);
    });
  }
};

/**
 * Remove data attributes on element of a jQuery selection
 *
 * @param jQueryElement a selection by jQuery
 * @param {Object, Array, String} data
 */
const removeDataTnrOnJQueryElement = (data, jQueryElement) => {
  jQueryElement.get().forEach(node => {
    removeDataTnrOnNode(data, node);
  });
};

/**
 * Add data attributes on a target
 *
 * @param target can be a selection by jQuery, a Node or a NodeList
 * @param {R, Array, String} data
 */
const addDataTnr = (data, target) => {
  if (target instanceof jQuery) {
    addDataTnrOnJQueryElement(data, target);
  } else if (target instanceof Node) {
    addDataTnrOnNode(data, target);
  } else if (target instanceof NodeList) {
    target.forEach(e => {
      addDataTnrOnNode(data, e);
    });
  }
};

/**
 * Remove data attributes on a target
 *
 * @param target can be a selection by jQuery, a Node or a NodeList
 * @param {Object, Array, String} data
 */
const removeDataTnr = (data, target) => {
  if (target instanceof jQuery) {
    removeDataTnrOnJQueryElement(data, target);
  } else if (target instanceof Node) {
    removeDataTnrOnNode(data, target);
  } else if (target instanceof NodeList) {
    target.forEach(e => {
      removeDataTnrOnNode(data, e);
    });
  }
};


export { setDataTnr, addDataTnr, removeDataTnr};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-tnr.js